<template>
  <v-app id="app">
    <div v-if="dev" class="dev-sign">
      <v-btn class="red white--text dev-btn">DEV</v-btn>
    </div>
    <div v-if="token">
      <v-toolbar class="green" fixed>
        <v-icon
          color="white"
          :style="mini ? 'margin-left:75px;' : 'margin-left:230px;'"
          @click="mini = !mini"
          >mdi-menu</v-icon
        >
        <v-spacer></v-spacer>
        <v-menu
          open-on-hover
          :close-delay="100"
          right
          offset-x
          :nudge-right="500"
          :nudge-bottom="30"
          :nudge-width="180"
        >
          <span slot="activator">
            <v-btn color="white" round medium>
              <img
                :src="logo_cl"
                alt="cl"
                width="25px"
                style="border-radius: 10px"
              />
              &nbsp; {{ username }}
            </v-btn>
          </span>
          <a @click="showProfile" class="mini-hover">
            <v-list-tile class="white mini-text">
              <v-icon class="mr-3 mini-icon">mdi-account</v-icon>Profile
            </v-list-tile>
          </a>

          <template v-if="accessApi === 'Yes'">
            <router-link to="/api" exact class="mini-hover">
              <v-list-tile class="white mini-text">
                <v-icon class="mr-3 mini-icon">mdi-key</v-icon>API Credential
              </v-list-tile>
            </router-link>
          </template>

          <a @click="logout" class="mini-hover">
            <v-list-tile class="white mini-text">
              <v-icon class="mr-3 mini-icon">mdi-logout</v-icon>Logout
            </v-list-tile>
          </a>
        </v-menu>
      </v-toolbar>
      <sidebar />
      <v-content>
        <v-container fluid>
          <ref-token v-if="timeout" :timeout="timeout" />
          <router-view :user="token"></router-view>
        </v-container>
      </v-content>
    </div>
    <div v-else>
      <Login />
    </div>
    <v-dialog v-model="show" max-width="350">
      <profile :isOrderV2="true" @closePop="show = $event" />
    </v-dialog>
    <v-dialog v-model="isOpenNewLanding" persistent>
      <img src="@/assets/new-ultragift.png" class="new-ultragift" @click="goToUltragift()" />
      <div class="countdown-redirect">Auto redirect in {{autoRedirect}}</div>
    </v-dialog>
  </v-app>
</template>

<script>
import Login from '@/views/Login.vue'
import RefToken from '@/components/RefToken.vue'
import Sidebar from '@/components/Sidebar.vue'
import Profile from '@/components/Profile'
import { mapState } from 'vuex'

export default {
  name: 'app',
  components: {
    Login,
    RefToken,
    Sidebar,
    Profile
  },
  data () {
    return {
      accessToken: null,
      timeout: false,
      show: false,
      dev: process.env.VUE_APP_MODE === 'development',
      isOpenNewLanding: true,
      autoRedirect: 10
    }
  },
  computed: {
    ...mapState([
      'appid',
      'appkey',
      'idClient',
      'token',
      'username',
      'receiver',
      'expired',
      'username',
      'logo_cl',
      'accessApi'
    ]),
    mini: {
      get: function () {
        return this.$store.getters.getMini
      },
      set: function (newValue) {
        this.$store.commit('setMini', newValue)
      }
    }
  },
  methods: {
    showProfile () {
      this.show = true
    },
    logout () {
      // localStorage.clear()
      localStorage.removeItem('_pid')
      localStorage.removeItem('_pky')
      localStorage.removeItem('_idc')
      localStorage.removeItem('_ict')
      localStorage.removeItem('t_tk')
      localStorage.removeItem('u_nm')
      localStorage.removeItem('e_rcv')
      localStorage.removeItem('lg_cl')
      localStorage.removeItem('xrd')
      localStorage.removeItem('as_api')
      window.location.reload()
    },
    goToUltragift () {
      window.open(
        this.dev
          ? 'https://staging.ultragift.co.id/'
          : 'https://ultragift.co.id/',
        '_self'
      )
    }
  },
  created () {
    setInterval(() => {
      if (this.autoRedirect > 1) {
        this.autoRedirect -= 1
      } else {
        this.goToUltragift()
      }
    }, 1000)
    let token = this.token
    let appid = this.appid
    let appkey = this.appkey
    let expired = this.expired
    if (
      !expired ||
      !appid ||
      !appkey ||
      !token ||
      new Date().getTime() - expired >= 4 * 60 * 60 * 1000
    ) {
      // localStorage.clear()
      // This catch below allows you to only avoid the error displaying, because browser thinks the exception was handled.
      this.$router.push('/').catch(() => {})
    }
    if (new Date().getTime() - expired >= 0) {
      this.timeout = true
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,600,700');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  scrollbar-color: lightgray gray;
}

#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: whitesmoke;
}
#nav {
  padding: 30px;
}

a {
  text-decoration: none;
}

i.primary--text::before {
  color: #4dbd77 !important;
}

.v-overlay {
  z-index: 21 !important;
}

.v-navigation-drawer--is-mobile,
.v-navigation-drawer--temporary {
  z-index: 11 !important;
}

.dev-sign {
  position: fixed;
  z-index: 100;
  transform: rotate(45deg);
  left: -5.2rem;
  bottom: 0;
}

.dev-btn {
  width: 180px;
}

.pointer {
  cursor: pointer !important;
}

.green {
  background-color: #4dbd77 !important;
  color: white !important;
}

v-list__tile__title,
.mini-hover .mini-text {
  font-size: 14px;
  color: #73818f;
  padding: 2px 0;
}

.router-link-active .v-list__tile__content,
.router-link-active .v-list__tile__title,
.router-link-active .v-list__tile__action i.v-icon,
.hover-inverted .v-list__tile:hover .v-list__tile__action i.v-icon {
  color: rgb(77, 189, 153);
  font-weight: 600;
}

.v-list__tile:hover .v-list__tile__title,
.v-list__tile:hover .v-list__tile__action i.v-icon,
.mini-hover:hover .mini-text,
.mini-hover:hover .mini-icon {
  color: white;
  font-weight: 600;
}

.v-navigation-drawer a:hover div[role='listitem'],
.mini-hover:hover .mini-text {
  background: rgb(77, 189, 153) !important;
}

.v-list__tile__action i.v-icon,
.mini-hover .mini-icon {
  color: white;
  display: inline-block;
  width: 1.09375rem;
  margin: 0 0.5rem 0 0;
  font-size: 1.4rem;
  text-align: center;
}
.v-dialog {
  box-shadow: none !important;
  width: auto !important;
  position: relative;
}
.new-ultragift {
  width: 1200px;
  max-width: 95vw;
  cursor: pointer;
}
.countdown-redirect {
  position: absolute;
  bottom: 0;
  right: 16px;
  font-weight: 600;
  color: #ededed;
}
</style>
